import { useEffect } from 'react'
import { EventContentPreview } from '../components/EventBody/EventBody'
import { EventGoalsAccordion } from '../components/EventFooter/EventGoalsAccordion'
import { EventHeader } from '../components/EventHeader/EventHeader'
import { useAppDispatch, useAppSelector } from '../redux/_reduxHooks'
import { protectedResources } from '../configs/protectedApis'
import { setCustomTopicLoading, setSelectedNwTopic } from '../redux/webSlice'
import { useParams } from 'react-router'
import callApi from '../services/callApi'
import { WebThemaDto } from '../types/webTypes/WebThemaDto'
import LoadingSpinner from '../global/LoadingSpinner'

const VideoEvent = () => {
  const dispatch = useAppDispatch()

  const webTopicData = useAppSelector((state) => state.web.selectedNwTopic)
  const topicLoading = useAppSelector((state) => state.web.customTopicLoading)

  const { topicUrlWithCode } = useParams()

  useEffect(() => {
    // Hole Thema Daten
    if (topicUrlWithCode) {
      // Extrahiere TopicCode aus URL, String nach letztem Vorkommen des Unterstrichs
      const extractedTopicCode = topicUrlWithCode.split('_').pop()

      const readWebEventUrl = `${protectedResources.apiList.readWebEvent}?thmcode=${extractedTopicCode}`

      dispatch(setCustomTopicLoading(true))
      callApi({ url: readWebEventUrl, method: 'GET', responseType: 'json' }).then((response) => {
        const responseData = response.data as WebThemaDto

        if (response.status === 200) {
          if (responseData.thmTyp === 'Videoaufzeichnung') {
            // Wenn Code OK und Videoaufzeichnung
            dispatch(setSelectedNwTopic(responseData))
            dispatch(setCustomTopicLoading(false))
          } else {
            //ToDo: Wenn nicht Video - Go Home
            //window.location.href = window.location.origin
          }
        } else if (response.status === 204) {
          // Wenn 204 (Code nicht ok, falsche URL) no content - Go Home
          window.location.href = window.location.origin
        }
      })
    }
  }, [topicUrlWithCode])

  // Setze Seitentitel
  useEffect(() => {
    if (webTopicData?.thmKurz) document.title = `${webTopicData?.thmKurz}`
  }, [webTopicData])

  return (
    <>
      {!topicLoading ? (
        <div className="seminardetail">
          <div>
            <EventHeader />
            <EventContentPreview />
          </div>
          <EventGoalsAccordion />
        </div>
      ) : (
        <LoadingSpinner />
      )}
    </>
  )
}

export default VideoEvent
